// extracted by mini-css-extract-plugin
export default {"info-button":"InfoModal--info-button--fQxXq","infoButton":"InfoModal--info-button--fQxXq"};